import { render, staticRenderFns } from "./settlementFreight.vue?vue&type=template&id=32e75689&scoped=true"
import script from "./settlementFreight.vue?vue&type=script&lang=ts"
export * from "./settlementFreight.vue?vue&type=script&lang=ts"
import style0 from "./settlementFreight.vue?vue&type=style&index=0&id=32e75689&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e75689",
  null
  
)

export default component.exports